var _path, _path2, _path3, _g, _path4, _path5, _path6, _circle, _path7, _path8, _path9, _path10, _path11;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAgreement(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    height: 512,
    viewBox: "0 0 64 64",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m51 9v17.32a47 47 0 0 1 -19 3.68 47 47 0 0 1 -19-3.68v-23.32a1 1 0 0 1 1-1h30z",
    fill: "#f2f2f2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m44 2v6a1 1 0 0 0 1 1h6z",
    fill: "#d9d9d9"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m47.32 51.67-17.44-10.93-5.88-2.24a11.52 11.52 0 0 1 -4.46-2.08l.7-1.21-7.42-4.21-8.66 15 7.38 4.21.79-1.38 3.59 2.64 13.72 8.13 3.51 2.12a2 2 0 0 0 2.74-.72 2.12 2.12 0 0 0 .28-1 2 2 0 0 0 -.94-1.7l1.68 1a2 2 0 1 0 2.09-3.37l1.71 1a2 2 0 1 0 2-3.4l2.55 1.53a2 2 0 0 0 2.74-.65 2 2 0 0 0 .29-1 2 2 0 0 0 -.97-1.74z",
    fill: "#ffd199"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#ffc780"
  }, /*#__PURE__*/React.createElement("rect", {
    height: 5.97,
    rx: 1.7,
    transform: "matrix(.824 .567 -.567 .824 32.94 -.66)",
    width: 3.98,
    x: 15.54,
    y: 49.68
  }), /*#__PURE__*/React.createElement("rect", {
    height: 6.96,
    rx: 1.7,
    transform: "matrix(.824 .567 -.567 .824 34.61 -2.35)",
    width: 3.98,
    x: 19.1,
    y: 51.02
  }), /*#__PURE__*/React.createElement("rect", {
    height: 5.97,
    rx: 1.7,
    transform: "matrix(.824 .567 -.567 .824 36.28 -4.04)",
    width: 3.98,
    x: 22.65,
    y: 53.37
  }), /*#__PURE__*/React.createElement("rect", {
    height: 4.97,
    rx: 1.7,
    transform: "matrix(.824 .567 -.567 .824 38.32 -5.27)",
    width: 3.98,
    x: 25.65,
    y: 56.53
  }), /*#__PURE__*/React.createElement("path", {
    d: "m52.51 29.69-7.87 3.8 1.08 2.2c-1.44.5-4.34.66-9.84-1.58-9.38-3.81-14.35 8-14.35 9.87s5.25 2.24 8.35-3.24l17 10.66a10.66 10.66 0 0 1 4.34-4.49l1 2.12 7.87-3.8z"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m60.16 45.23-7.87 3.77-1-2.12a10.66 10.66 0 0 0 -4.39 4.52l-17-10.66c-3.1 5.48-8.35 5.14-8.35 3.24a7.56 7.56 0 0 1 .71-2.36c1.74.38 4.91-.62 7.06-4.42l17 10.66a10.66 10.66 0 0 1 4.34-4.49l1 2.12 6.93-3.33z",
    fill: "#e6b373"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m52.51 29.69-7.87 3.8 7.65 15.54 7.87-3.8z",
    fill: "#4d9aff"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "m12.82 31 7.38 4.21-8.66 15-7.38-4.21z",
    fill: "#ff7375"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 17,
    fill: "#67cc6d",
    r: 9
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "m52.75 47.7-6.75-13.7 7-3.36-.87-1.8-7.87 3.8a1 1 0 0 0 -.46 1.34l.51 1c-1.44.13-3.92-.13-8-1.78a9.58 9.58 0 0 0 -9.31.86 14.37 14.37 0 0 0 -3.38 3.31 10.52 10.52 0 0 1 -2.74-1.24l.24-.41a1 1 0 0 0 .1-.76 1 1 0 0 0 -.47-.61l-7.37-4.21-1 1.73 6.51 3.72-7.72 13.26-6.51-3.72-1 1.73 7.34 4.22a1 1 0 0 0 1.36-.37l.24-.41 1.91 1.41-.21.31a2.67 2.67 0 0 0 -.43 2 2.7 2.7 0 0 0 1.13 1.76l.47.32a2.71 2.71 0 0 0 1.53.48 1.81 1.81 0 0 0 .23 0 2.59 2.59 0 0 0 1 1.48l.47.33a2.67 2.67 0 0 0 1.52.47 2.74 2.74 0 0 0 .5 0 2.62 2.62 0 0 0 .56-.18 2.81 2.81 0 0 0 .79.86l.47.32a2.68 2.68 0 0 0 1.52.48h.24a2.61 2.61 0 0 0 1.05 1.47l.46.32a2.67 2.67 0 0 0 1.52.47 2.72 2.72 0 0 0 2.24-1.17l.28-.41 2.7 1.63a3 3 0 0 0 1.53.43 3 3 0 0 0 2.57-1.45 2.87 2.87 0 0 0 .37-1 2.91 2.91 0 0 0 .82.12 3 3 0 0 0 2.57-1.45 3.08 3.08 0 0 0 .38-1.05 2.74 2.74 0 0 0 .81.12 3 3 0 0 0 2.56-1.45 2.91 2.91 0 0 0 .36-.94l.15.09a3 3 0 0 0 1.54.43 3 3 0 0 0 2.57-1.45 3 3 0 0 0 .42-1.54 3 3 0 0 0 -1-2.25 9.88 9.88 0 0 1 2.58-2.81l.57 1.15a1 1 0 0 0 .9.56 1 1 0 0 0 .43-.1l7.87-3.8-.87-1.8zm-35.13 6.57a.71.71 0 0 1 -1 .18l-.47-.32a.71.71 0 0 1 -.18-1l1.47-2.13a.7.7 0 0 1 .45-.29.71.71 0 0 1 .53.12l.46.32a.63.63 0 0 1 .29.45.67.67 0 0 1 -.11.53zm3.27 2.26a.7.7 0 0 1 -.45.29.76.76 0 0 1 -.53-.11l-.47-.32a.71.71 0 0 1 -.18-1l2-2.93a.67.67 0 0 1 .45-.29h.13a.72.72 0 0 1 .4.12l.46.32a.73.73 0 0 1 .3.45.7.7 0 0 1 -.12.53zm3.84 1.47a.71.71 0 0 1 -1 .18l-.47-.32a.73.73 0 0 1 -.29-.45.76.76 0 0 1 .11-.53l1.45-2.1a.72.72 0 0 1 1-.19l.47.33a.71.71 0 0 1 .18 1zm4.16 1-.89 1.22a.73.73 0 0 1 -1 .18l-.47-.32a.71.71 0 0 1 -.18-1l.89-1.29a.71.71 0 0 1 1-.18l.46.32a.71.71 0 0 1 .19 1zm18.26-5a1 1 0 0 1 -.61.45 1 1 0 0 1 -.75-.11l-6-3.59-1 1.71 3.41 2a1 1 0 0 1 .45.61 1 1 0 0 1 -.11.75 1 1 0 0 1 -.61.45 1 1 0 0 1 -.75-.11l-4.26-2.57-1 1.71 2.56 1.54a1.06 1.06 0 0 1 .45.61 1 1 0 0 1 -1.47 1.09l-4.26-2.57-1 1.71 2.57 1.56a1 1 0 0 1 -1 1.68l-2.84-1.72a2.83 2.83 0 0 0 .07-1.2 2.7 2.7 0 0 0 -1.12-1.74l-.5-.26a2.64 2.64 0 0 0 -1.08-.43 2.83 2.83 0 0 0 0-.58 2.65 2.65 0 0 0 -1.13-1.74l-.46-.32a2.69 2.69 0 0 0 -1.76-.46 2.67 2.67 0 0 0 -1.09-1.47l-.47-.32a2.68 2.68 0 0 0 -2-.43 3.06 3.06 0 0 0 -.56.17 2.78 2.78 0 0 0 -.79-.85l-.47-.32a2.71 2.71 0 0 0 -3.76.69l-.1.15-2-1.5 6.18-10.7a12.52 12.52 0 0 0 2.59 1.24 12.78 12.78 0 0 0 -1.95 4.87 2.26 2.26 0 0 0 1.89 2.12c1.82.48 5.26-.25 7.78-4l16.6 10.41a1 1 0 0 1 .49.85 1 1 0 0 1 -.14.51zm-.58-4-7.36-4.61a8 8 0 0 0 2.69-2.54l-1.74-1a6.43 6.43 0 0 1 -2.92 2.29l-6.83-4.28a1 1 0 0 0 -.78-.12 1 1 0 0 0 -.62.47c-1.67 2.95-4 4-5.47 4a1.48 1.48 0 0 1 -1-.26 15 15 0 0 1 5.52-8.27 7.54 7.54 0 0 1 7.44-.68c4.1 1.67 7.35 2.27 9.68 1.82l4.75 9.65a12.09 12.09 0 0 0 -3.36 3.53z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "m53.76 42.83h2.22v2h-2.22z",
    transform: "matrix(.897 -.441 .441 .897 -13.71 28.72)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "m52 26v-17a1 1 0 0 0 -.29-.71l-7-7a1 1 0 0 0 -.71-.29h-30a2 2 0 0 0 -2 2v24h2v-24h29v5a2 2 0 0 0 2 2h5v16zm-7-18v-3.59l3.59 3.59z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "m22 17a10 10 0 1 0 10-10 10 10 0 0 0 -10 10zm18 0a8 8 0 1 1 -8-8 8 8 0 0 1 8 8z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "m28.29 16.85-1.42 1.42 2.48 2.47a1 1 0 0 0 1.41 0l6.37-6.36-1.42-1.38-5.65 5.66z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAgreement);
export default __webpack_public_path__ + "static/media/agreement.a49331710e845826d27128c73df57ae0.svg";
export { ForwardRef as ReactComponent };